import { useState, useEffect } from "react";
import ShopingContext from "./ShopingContext";

const ShopingProvider = ({ children }) => {
  const [category, setCategory] = useState([]);
  const [product, setProduct] = useState([]);
  const [selectedCategoryID, setSelectedCategoryID] = useState("-1"); // Default All
// Inside your component
const [cartItems, setCartItems] = useState([]);
const [snackbarOpen, setSnackbarOpen] = useState(false);
// Load cart from session storage on mount
useEffect(() => {
  const savedCart = sessionStorage.getItem('cart');
  if (savedCart) {
    setCartItems(JSON.parse(savedCart));
  }
}, []);
// Inside ShopingProvider component
useEffect(() => {
  const handleCartUpdate = () => {
    const savedCart = sessionStorage.getItem('cart');
    if (savedCart) {
      setCartItems(JSON.parse(savedCart));
    }
  };

  // Listen for both storage events and custom events
  window.addEventListener('storage', handleCartUpdate);
  window.addEventListener('cartUpdated', handleCartUpdate);

  return () => {
    window.removeEventListener('storage', handleCartUpdate);
    window.removeEventListener('cartUpdated', handleCartUpdate);
  };
}, []);
useEffect(() => {
  // This will re-run whenever cartItems changes
  console.log("Cart length updated", cartItems.length);
}, [cartItems]);


// Add to cart function
const addToCart = (product) => {
  // Check if product already exists in cart
  const existingIndex = cartItems.findIndex(
    item => item.ProdtID === product.ProdtID
  );

  let updatedCart;
  if (existingIndex !== -1) {
    // If exists, update quantity
    updatedCart = [...cartItems];
    updatedCart[existingIndex] = {
      ...updatedCart[existingIndex],
      quantity: updatedCart[existingIndex].quantity + 1,
      total: updatedCart[existingIndex].ProdRetailPrice * 
            (updatedCart[existingIndex].quantity + 1)
    };
  } else {
    // If new, add with quantity 1
    const productWithQuantity = {
      ...product,
      quantity: 1,
      total: product.ProdRetailPrice * 1
    };
    updatedCart = [...cartItems, productWithQuantity];
  }

  setCartItems(updatedCart);
  sessionStorage.setItem("cart", JSON.stringify(updatedCart));
  setSnackbarOpen(true);
};


  useEffect(() => {
    const fetchCategory = async () => {
      try {
        const response = await fetch("https://testing.esnep.com/magnessa/api/vendor/product", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ ComID: "EH25", Flag: "SC" }),
        });
  
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
  
        const data = await response.json();
        setCategory(data.ProdLst || []);  
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };
  
    fetchCategory();
  }, []);


  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await fetch("https://testing.esnep.com/magnessa/api/vendor/product", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ ComID: "EH25", Flag: "S",CategoryID:selectedCategoryID }),
        });
  
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
  
        const data = await response.json();
        setProduct(data.ProdLst || []);  
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };
  
    fetchProduct();
  }, [selectedCategoryID ]);
  


  return (
    <ShopingContext.Provider value={{ category,product,selectedCategoryID, setSelectedCategoryID,cartItems,addToCart,setSnackbarOpen,snackbarOpen  }}>
      {children}
    </ShopingContext.Provider>
  );
};

export default ShopingProvider;